import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _asyncIterator(r) { var n, t, o, e = 2; for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--;) { if (t && null != (n = r[t])) return n.call(r); if (o && null != (n = r[o])) return new AsyncFromSyncIterator(n.call(r)); t = "@@asyncIterator", o = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(r) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var n = r.done; return Promise.resolve(r.value).then(function (r) { return { value: r, done: n }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(r) { this.s = r, this.n = r.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, "return": function _return(r) { var n = this.s["return"]; return void 0 === n ? Promise.resolve({ value: r, done: !0 }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); }, "throw": function _throw(r) { var n = this.s["return"]; return void 0 === n ? Promise.reject(r) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(r); }
/**
 * Chat client for orqestrator.
 *
 * Thin by design. Request shaping lives in `request.ts`, event folding in
 * `run.ts`, SSE decoding in `sse.ts`; what is left here is the part that is
 * genuinely about talking to the network: the fetch, the auth retry, and the
 * two endpoint quirks that force a fallback.
 *
 * The browser calls orqestrator directly rather than proxying through the
 * platform, so this is a cross-origin request carrying the httpOnly
 * `access_token` cookie the platform minted. No credential appears in this
 * file: `credentials: "include"` is the whole of it, and the browser does the
 * rest.
 *
 * Uses `fetch` rather than the app's axios instance, which is a deliberate
 * exception to the convention in `token.ts`. Two reasons: axios has no
 * streaming response type in the version pinned here, and the base URL is
 * orqestrator rather than the platform API `axiosConnect` is configured for.
 * Everything non-streaming still goes through `servicesUtils`.
 */
import { OrqChatError } from "./errors";
import { buildRequestBody, CHAT_PATH } from "./request";
import { RunAccumulator } from "./run";
import { readJSONEvents } from "./sse";
export var OrqClient = /*#__PURE__*/function () {
  function OrqClient(opts) {
    var _opts$fetchImpl, _opts$mintToken;
    _classCallCheck(this, OrqClient);
    this.opts = opts;
    this.doFetch = (_opts$fetchImpl = opts.fetchImpl) !== null && _opts$fetchImpl !== void 0 ? _opts$fetchImpl : function () {
      return fetch.apply(void 0, arguments);
    };
    this.mint = (_opts$mintToken = opts.mintToken) !== null && _opts$mintToken !== void 0 ? _opts$mintToken : /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _yield$import, mintOrqToken;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return import("./token");
          case 1:
            _yield$import = _context.v;
            mintOrqToken = _yield$import.mintOrqToken;
            return _context.a(2, mintOrqToken());
        }
      }, _callee);
    }));
  }

  /**
   * Stream one chat turn.
   *
   * Resolves when the stream closes. `handlers.onDone` fires exactly once
   * either way, including on abort or a dropped connection, so a caller's
   * spinner can never be left running.
   */
  return _createClass(OrqClient, [{
    key: "streamChat",
    value: (function () {
      var _streamChat = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(req) {
        var _res$headers$get, _res$headers$get2;
        var handlers,
          signal,
          res,
          run,
          _iteratorAbruptCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          ev,
          _args2 = arguments,
          _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              handlers = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              signal = _args2.length > 2 ? _args2[2] : undefined;
              _context2.n = 1;
              return this.sendWithRetry(_objectSpread(_objectSpread({}, req), {}, {
                responseMode: "stream_text"
              }), handlers, signal);
            case 1:
              res = _context2.v;
              if (res.body) {
                _context2.n = 3;
                break;
              }
              _context2.n = 2;
              return this.fail(res, handlers, "orqestrator returned no response body");
            case 2:
              throw _context2.v;
            case 3:
              // A streamed body has no envelope to carry the conversation id, so it
              // arrives as a header. Without it a new thread could never be resumed.
              run = new RunAccumulator({
                conversationId: (_res$headers$get = res.headers.get("x-conversation-id")) !== null && _res$headers$get !== void 0 ? _res$headers$get : req.conversationId,
                traceId: (_res$headers$get2 = res.headers.get("x-trace-id")) !== null && _res$headers$get2 !== void 0 ? _res$headers$get2 : undefined
              });
              _context2.p = 4;
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context2.p = 5;
              _iterator = _asyncIterator(readJSONEvents(res.body, signal));
            case 6:
              _context2.n = 7;
              return _iterator.next();
            case 7:
              if (!(_iteratorAbruptCompletion = !(_step = _context2.v).done)) {
                _context2.n = 9;
                break;
              }
              ev = _step.value;
              run.apply(ev, handlers);
            case 8:
              _iteratorAbruptCompletion = false;
              _context2.n = 6;
              break;
            case 9:
              _context2.n = 11;
              break;
            case 10:
              _context2.p = 10;
              _t = _context2.v;
              _didIteratorError = true;
              _iteratorError = _t;
            case 11:
              _context2.p = 11;
              _context2.p = 12;
              if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) {
                _context2.n = 13;
                break;
              }
              _context2.n = 13;
              return _iterator["return"]();
            case 13:
              _context2.p = 13;
              if (!_didIteratorError) {
                _context2.n = 14;
                break;
              }
              throw _iteratorError;
            case 14:
              return _context2.f(13);
            case 15:
              return _context2.f(11);
            case 16:
              _context2.p = 16;
              // An abort or dropped connection yields no RUN_FINISHED, so the caller's
              // spinner is cleared here too. `finish` is idempotent.
              run.finish(handlers);
              return _context2.f(16);
            case 17:
              if (!run.errored) {
                _context2.n = 18;
                break;
              }
              throw new OrqChatError(run.errored);
            case 18:
              return _context2.a(2, run.result);
          }
        }, _callee2, this, [[12,, 13, 15], [5, 10, 11, 16], [4,, 16, 17]]);
      }));
      function streamChat(_x) {
        return _streamChat.apply(this, arguments);
      }
      return streamChat;
    }() /** Non-streaming turn. Same auth path; returns the whole reply at once. */)
  }, {
    key: "sendChat",
    value: (function () {
      var _sendChat = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(req, signal) {
        var _json$content;
        var res, json;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.sendWithRetry(_objectSpread(_objectSpread({}, req), {}, {
                responseMode: "sync"
              }), {}, signal);
            case 1:
              res = _context3.v;
              _context3.n = 2;
              return res.json();
            case 2:
              json = _context3.v;
              return _context3.a(2, {
                conversationId: json.conversation_id,
                text: (_json$content = json.content) !== null && _json$content !== void 0 ? _json$content : "",
                finished: true,
                toolCalls: [],
                traceId: json.trace_id
              });
          }
        }, _callee3, this);
      }));
      function sendChat(_x2, _x3) {
        return _sendChat.apply(this, arguments);
      }
      return sendChat;
    }()
    /**
     * POST the turn, re-minting once on 401.
     *
     * The cookie is short-lived by design, so expiry mid-session is the expected
     * case rather than an error, and re-minting is cheaper than tracking the
     * clock: the cookie is httpOnly, so its `exp` is not readable from here.
     */
    )
  }, {
    key: "sendWithRetry",
    value: (function () {
      var _sendWithRetry = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(req) {
        var handlers,
          signal,
          res,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              handlers = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
              signal = _args4.length > 2 ? _args4[2] : undefined;
              _context4.n = 1;
              return this.post(req, signal);
            case 1:
              res = _context4.v;
              if (!(res.status === 401)) {
                _context4.n = 5;
                break;
              }
              _context4.n = 2;
              return this.mint();
            case 2:
              _context4.n = 3;
              return this.post(req, signal);
            case 3:
              res = _context4.v;
              if (!(res.status === 401)) {
                _context4.n = 5;
                break;
              }
              _context4.n = 4;
              return this.fail(res, handlers, "orqestrator rejected a freshly minted token; the access_token cookie was probably not stored");
            case 4:
              throw _context4.v;
            case 5:
              if (res.ok) {
                _context4.n = 7;
                break;
              }
              _context4.n = 6;
              return this.fail(res, handlers, "orqestrator ".concat(res.status));
            case 6:
              throw _context4.v;
            case 7:
              return _context4.a(2, res);
          }
        }, _callee4, this);
      }));
      function sendWithRetry(_x4) {
        return _sendWithRetry.apply(this, arguments);
      }
      return sendWithRetry;
    }() /** Build the error, notify the handlers, and settle them. Always throws. */)
  }, {
    key: "fail",
    value: (function () {
      var _fail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(res, handlers, message) {
        var _handlers$onError, _handlers$onDone;
        var err, _t2, _t3, _t4, _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _t2 = OrqChatError;
              _t3 = message;
              _t4 = res.status;
              _context5.n = 1;
              return safeText(res);
            case 1:
              _t5 = _context5.v;
              err = new _t2(_t3, _t4, _t5);
              (_handlers$onError = handlers.onError) === null || _handlers$onError === void 0 || _handlers$onError.call(handlers, err.message);
              (_handlers$onDone = handlers.onDone) === null || _handlers$onDone === void 0 || _handlers$onDone.call(handlers);
              return _context5.a(2, err);
          }
        }, _callee5);
      }));
      function fail(_x5, _x6, _x7) {
        return _fail.apply(this, arguments);
      }
      return fail;
    }()
    /** Run a sync turn but deliver it through the streaming handlers, so callers
     *  do not need two code paths for the resumed-thread case. */
    )
  }, {
    key: "syncAsStream",
    value: (function () {
      var _syncAsStream = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(req, handlers, signal) {
        var _handlers$onStart;
        var _handlers$onText, res, _handlers$onError2, _handlers$onDone2, _t6;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              (_handlers$onStart = handlers.onStart) === null || _handlers$onStart === void 0 || _handlers$onStart.call(handlers, {});
              _context6.p = 1;
              _context6.n = 2;
              return this.sendChat(req, signal);
            case 2:
              res = _context6.v;
              if (res.text) (_handlers$onText = handlers.onText) === null || _handlers$onText === void 0 || _handlers$onText.call(handlers, res.text);
              return _context6.a(2, res);
            case 3:
              _context6.p = 3;
              _t6 = _context6.v;
              (_handlers$onError2 = handlers.onError) === null || _handlers$onError2 === void 0 || _handlers$onError2.call(handlers, errMessage(_t6));
              throw _t6;
            case 4:
              _context6.p = 4;
              (_handlers$onDone2 = handlers.onDone) === null || _handlers$onDone2 === void 0 || _handlers$onDone2.call(handlers);
              return _context6.f(4);
            case 5:
              return _context6.a(2);
          }
        }, _callee6, this, [[1, 3, 4, 5]]);
      }));
      function syncAsStream(_x8, _x9, _x0) {
        return _syncAsStream.apply(this, arguments);
      }
      return syncAsStream;
    }()
    /**
     * Replay a conversation.
     *
     * Returns the newest page; pass `before` from `nextCursor` to walk backwards.
     * A 404 means the thread is gone (or was never ours) rather than an outage,
     * so it yields an empty page and the chat simply starts fresh.
     */
    )
  }, {
    key: "getHistory",
    value: (function () {
      var _getHistory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(conversationId) {
        var _json$messages, _json$next_cursor;
        var opts,
          _this$opts,
          baseUrl,
          projectId,
          params,
          url,
          res,
          json,
          _args7 = arguments,
          _t7,
          _t8,
          _t9,
          _t0;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              opts = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
              _this$opts = this.opts, baseUrl = _this$opts.baseUrl, projectId = _this$opts.projectId;
              params = new URLSearchParams({
                project_id: projectId
              });
              if (opts.limit) params.set("limit", String(opts.limit));
              if (opts.before) params.set("before", opts.before);
              url = "".concat(baseUrl).concat(CHAT_PATH, "/").concat(encodeURIComponent(conversationId), "?").concat(params);
              _context7.n = 1;
              return this.doFetch(url, {
                method: "GET",
                credentials: "include"
              });
            case 1:
              res = _context7.v;
              if (!(res.status === 401)) {
                _context7.n = 4;
                break;
              }
              _context7.n = 2;
              return this.mint();
            case 2:
              _context7.n = 3;
              return this.doFetch(url, {
                method: "GET",
                credentials: "include"
              });
            case 3:
              res = _context7.v;
            case 4:
              if (!(res.status === 404)) {
                _context7.n = 5;
                break;
              }
              return _context7.a(2, {
                conversationId: conversationId,
                messages: [],
                nextCursor: null
              });
            case 5:
              if (res.ok) {
                _context7.n = 7;
                break;
              }
              _t7 = OrqChatError;
              _t8 = "orqestrator ".concat(res.status);
              _t9 = res.status;
              _context7.n = 6;
              return safeText(res);
            case 6:
              _t0 = _context7.v;
              throw new _t7(_t8, _t9, _t0);
            case 7:
              _context7.n = 8;
              return res.json();
            case 8:
              json = _context7.v;
              return _context7.a(2, {
                conversationId: json.conversation_id,
                messages: (_json$messages = json.messages) !== null && _json$messages !== void 0 ? _json$messages : [],
                nextCursor: (_json$next_cursor = json.next_cursor) !== null && _json$next_cursor !== void 0 ? _json$next_cursor : null
              });
          }
        }, _callee7, this);
      }));
      function getHistory(_x1) {
        return _getHistory.apply(this, arguments);
      }
      return getHistory;
    }())
  }, {
    key: "post",
    value: function post(req, signal) {
      var _this$opts2 = this.opts,
        baseUrl = _this$opts2.baseUrl,
        projectId = _this$opts2.projectId;
      return this.doFetch("".concat(baseUrl).concat(CHAT_PATH), {
        method: "POST",
        // Mandatory. Without it the access_token cookie is never sent and every
        // request is a 401.
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(buildRequestBody(req, projectId)),
        signal: signal
      });
    }
  }]);
}();

/** Best-effort human-readable message from an unknown thrown value. */
function errMessage(err) {
  return err instanceof Error ? err.message : String(err);
}
function safeText(_x10) {
  return _safeText.apply(this, arguments);
}
function _safeText() {
  _safeText = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(res) {
    var _t1;
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.p = _context8.n) {
        case 0:
          _context8.p = 0;
          _context8.n = 1;
          return res.text();
        case 1:
          return _context8.a(2, _context8.v.slice(0, 500));
        case 2:
          _context8.p = 2;
          _t1 = _context8.v;
          return _context8.a(2, "");
      }
    }, _callee8, null, [[0, 2]]);
  }));
  return _safeText.apply(this, arguments);
}